import FontFaceObserver from 'fontfaceobserver';

export function initFontFace() {
  document.querySelectorAll<HTMLLinkElement>('link[as="font"]').forEach(el => {
    const fontId = new URL(el.href).pathname
      .replace(/.*\/|-(?:v\d+|bold|regular|light).*|\..*/gi, '')
      .toLowerCase();

    new FontFaceObserver(fontId.replace(/-/g, ' '))
      .load()
      .then(function () {
        document.body.classList.add(`wf-${fontId}`);
      })
      .catch(err => {
        console.log(fontId);
        console.error(err);
      });
  });
}
